import React from "react"
import ReactSelect from "react-select"
import { Switch } from "react-router-dom"
import { default as Route } from "../../../routes/CustomRoute"
import AnalyticsLayout from "./AnalyticsLayout"
import Store from "./Contributors"
import Objectives from "./Objectives"
import Sales from "./Sales"
import AnalyticsGDS from './GoogleDataStudio'
import { withAnalyticsContainer } from "../normalizer"
import EmptyStateLayout from "../shared/EmptyStateLayout"
import { ReactComponent as NoStore } from "../../../assets/img/no_store.svg"

const Analytics = ({ client, stores, selectedGroup, onGroupSelection, campaignUser }) => {
  const message =
    stores.length > 1 ? "Comece por selecionar uma loja..." : "A carregar..."

  const formatStoreLabel = (option) => {
    const name = option.name || option.external_identifier || ''
    const id = option.external_identifier
    return id ? `${name} (${id})` : name
  }

  return (
    <div className="analytics-layout">
      <div className="analytics-layout-header">
        <h4 className="analytics-layout-header-title">Dashboard</h4>
      </div>
      {stores.length > 1 && (
        <div className="analytics-layout-options">
          <div className="analytics-layout-options-drop">
            <ReactSelect
              options={stores}
              onChange={onGroupSelection}
              getOptionLabel={formatStoreLabel}
              getOptionValue={option => option.id}
              value={selectedGroup}
              placeholder={"Escolha uma loja..."}
              noOptionsMessage={() => "A loja que procura não existe..."}
              className="analytics-layout-options-drop-select"
              classNamePrefix="gl-custom-select"
            />
          </div>
        </div>
      )}
      {selectedGroup ? (
        <AnalyticsLayout client={client} group={selectedGroup} campaignUser={campaignUser}>
          <Switch>
            <Route
              exact
              path="/analytics/:id"
              component={Store}
              group={selectedGroup}
            />
            <Route
              exact
              path="/analytics/:id/sales"
              component={Sales}
              group={selectedGroup}
            />
            <Route
              exact
              path="/analytics/:id/objectives"
              component={Objectives}
              group={selectedGroup}
            />
            <Route
              exact
              path="/analytics/:id/gds"
              component={AnalyticsGDS}
              group={selectedGroup}
            />
          </Switch>
        </AnalyticsLayout>
      ) : (
        <EmptyStateLayout message={message}>
          <div className="gl-no-store">
            <NoStore className="mr-3 dead-grey gl-no-store__image" />
          </div>
        </EmptyStateLayout>
      )}
    </div>
  )
}

export default withAnalyticsContainer(Analytics)
